import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, createContext, useEffect } from "react";
import { getSharedUiHeaderBffData } from "../utils/api";
export var SharedUiHeaderV2Context = /*#__PURE__*/ createContext({});
export var SharedUiHeaderV2Provider = function(param) {
    var children = param.children, stageName = param.stageName, isLoggedIn = param.isLoggedIn, accessToken = param.accessToken, firstName = param.firstName, favourites = param.favourites, activeOrder = param.activeOrder, handleTrackEvent = param.handleTrackEvent, refreshActiveOrder = param.refreshActiveOrder, setIsCheckoutModalVisible = param.setIsCheckoutModalVisible, isCheckoutModalVisible = param.isCheckoutModalVisible, isGapMenuItemShown = param.isGapMenuItemShown, isUpdatedCinchCareCopy = param.isUpdatedCinchCareCopy;
    var ref = useState({
        stageName: stageName,
        isLoggedIn: isLoggedIn,
        accessToken: accessToken,
        firstName: firstName,
        favourites: favourites,
        activeOrder: activeOrder,
        refreshActiveOrder: refreshActiveOrder
    }), userStore = ref[0], setUserStore = ref[1];
    var ref1 = useState({
        handleTrackEvent: handleTrackEvent,
        setIsCheckoutModalVisible: setIsCheckoutModalVisible,
        isCheckoutModalVisible: isCheckoutModalVisible,
        searchData: null
    }), logicStore = ref1[0], setLogicStore = ref1[1];
    useEffect(function() {
        setLogicStore({
            handleTrackEvent: handleTrackEvent,
            setIsCheckoutModalVisible: setIsCheckoutModalVisible,
            isCheckoutModalVisible: isCheckoutModalVisible,
            searchData: null
        });
        setUserStore({
            stageName: stageName,
            isLoggedIn: isLoggedIn,
            accessToken: accessToken,
            firstName: firstName,
            favourites: favourites,
            activeOrder: activeOrder,
            refreshActiveOrder: refreshActiveOrder
        });
    }, [
        stageName,
        isLoggedIn,
        accessToken,
        firstName,
        favourites,
        activeOrder,
        refreshActiveOrder,
        setIsCheckoutModalVisible,
        isCheckoutModalVisible, 
    ]);
    useEffect(function() {
        var getSearchData = function() {
            var _ref = _async_to_generator(function() {
                var searchData, findACarSearchData, popularMakes;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getSharedUiHeaderBffData()
                            ];
                        case 1:
                            searchData = _state.sent();
                            if (// eslint-disable-next-line no-prototype-builtins
                            (searchData === null || searchData === void 0 ? void 0 : searchData.hasOwnProperty("find-a-car")) && // eslint-disable-next-line no-prototype-builtins
                            (searchData === null || searchData === void 0 ? void 0 : searchData["find-a-car"].hasOwnProperty("popular-makes"))) {
                                findACarSearchData = searchData["find-a-car"];
                                popularMakes = findACarSearchData["popular-makes"];
                                setLogicStore(_object_spread_props(_object_spread({}, logicStore), {
                                    searchData: popularMakes
                                }));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function getSearchData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (logicStore.searchData === null) {
            getSearchData();
        }
    }, [
        logicStore.searchData
    ]);
    return /*#__PURE__*/ _jsx(SharedUiHeaderV2Context.Provider, {
        value: {
            userStore: userStore,
            setUserStore: setUserStore,
            logicStore: logicStore,
            setLogicStore: setLogicStore,
            isGapMenuItemShown: isGapMenuItemShown,
            isUpdatedCinchCareCopy: isUpdatedCinchCareCopy
        },
        children: children
    });
};
